import { render, staticRenderFns } from "./GestioneLotti.vue?vue&type=template&id=c6b5a7da&"
import script from "./GestioneLotti.vue?vue&type=script&lang=js&"
export * from "./GestioneLotti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports